import React, { useState } from 'react'
import { ExpandMore } from '@mui/icons-material'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from '@mui/material'
import CustomField from './CustomField'
import InputGroup from '../InputGroup'
import AccordionHeader from '../AccordionHeader'
import useAlert from '../../../hooks/useAlert'
import Tooltip from '../../../common/Tooltip'

const CustomFields = ({
  customer,
  setCustomer,
  customFields,
  customFieldTypes,
  isNew,
  reset,
  saveCustomer,
  expandedAccordions,
  setExpandedAccordions,
  renderedSaveButton,
}) => {
  const expanded = expandedAccordions.custom
  const setExpanded = (val) =>
    setExpandedAccordions((prev) => ({ ...prev, custom: val }))

  const [editing, setEditing] = useState(true)

  const { createAlert, createGenericErrorAlert } = useAlert()

  const handleSaveCustomFields = () => {
    saveCustomer({ saveCustomFields: true })
      .then(() => {
        // setEditing(false)
        createAlert({ message: 'Custom fields saved successfully' })
      })
      .catch(() => {
        createGenericErrorAlert()
      })
  }

  const displayCustomFields = customFields.sort((a, b) => {
    if (a.typeId === b.typeId) return 0
    if (a.typeId === 5) return 1
    if (b.typeId === 5) return -1
  })

  return (
    <Accordion
      elevation={8}
      sx={{ width: '100%', minWidth: '340px', maxWidth: '1250px' }}
      expanded={expanded}
      onChange={(_, isExpanded) => setExpanded(isExpanded)}
    >
      <AccordionSummary expandIcon={<ExpandMore />}>
        <Typography sx={{ display: 'flex', alignItems: 'center' }}>
          <b>Custom Fields</b>

          <Tooltip
            infoText={
              'In this section you can track “Custom Fields” that have been created by your administrator to suit your business needs.'
            }
          />
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AccordionHeader
          hide={isNew}
          setIsEditing={setEditing}
          isEditing={editing}
          onSave={handleSaveCustomFields}
          onCancel={() => reset({ resetCustomFields: true })}
        />
        <>
          <InputGroup sx={{ justifyContent: 'flex-start' }}>
            {displayCustomFields.map((c, i) => (
              <Box
                key={c.id}
                sx={{
                  width: 'calc(25% - 8px)',
                  mx: 0.5,
                  flexGrow: 1,
                  minWidth: '225px',
                }}
              >
                <CustomField
                  field={c}
                  types={customFieldTypes}
                  editing={editing}
                  onChange={(key, value) => {
                    setCustomer((c) => ({
                      ...c,
                      customFields: { ...c.customFields, [key]: value },
                    }))
                  }}
                  value={customer.customFields?.[c.id]}
                ></CustomField>
              </Box>
            ))}
          </InputGroup>
        </>

        <Box
          sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2, mr: -2 }}
        >
          {renderedSaveButton && renderedSaveButton}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export default CustomFields
